<template>
  <div>
    <v-row class="d-flex">
      <v-col cols="4">
        <entity-filter />
      </v-col>
      <v-col cols="4">
        <source-filter />
      </v-col>
    </v-row>
    <v-row class="d-flex">
      <v-col cols="4">
        <search-filter />
      </v-col>
      <v-col cols="4">
        <replace-filter />
      </v-col>

      <v-col cols="4" class="d-flex">
        <v-spacer />
        <apply-filters :disabled="isLoading" outlined color="secondary" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import useAxios from "@/hooks/useAxios";

import ApplyFilters from "@/components/common/filters/ApplyFilters.vue";
import EntityFilter from "@/components/finance/mapping/filters/EntityFilter";
import ReplaceFilter from "@/components/finance/mapping/filters/ReplaceFilter";
import SearchFilter from "@/components/finance/mapping/filters/SearchFilter";
import SourceFilter from "@/components/finance/mapping/filters/SourceFilter";

const COMPONENT_NAME = "Filters";

export default {
  name: COMPONENT_NAME,
  components: {
    ApplyFilters,
    EntityFilter,
    SearchFilter,
    SourceFilter,
    ReplaceFilter,
  },
  setup(props, { emit }) {
    const { isLoading } = useAxios();

    // =>  METHODS

    // =>  COMPUTED

    // =>  WATCH

    // =>  HOOKS

    // =>  DATA
    return {
      isLoading,
    };
  },
};
</script>

<style></style>
